import BaseRepository from '@/api/BaseRepository';

export default class UserRepository extends BaseRepository {

    private userRoute = 'user';
    private adminRoute = 'admin';

    public async getAllUsers(): Promise<any> {
        return this.axiosClient.get(`${this.userRoute}`);
    }

    public async listUsers(): Promise<any> {
        return this.axiosClient.get(`${this.adminRoute}/users`);
    }

    public async createUser(userData: { username: string; password: string; firstName?: string; lastName?: string; email?: string; phone?: string; role?: string }): Promise<any> {
        return this.axiosClient.post(`${this.adminRoute}/user`, userData);
    }

    public async updateUser(userId: string, userData: { firstName?: string; lastName?: string; email?: string; phone?: string; role?: string }): Promise<any> {
        return this.axiosClient.put(`${this.adminRoute}/user/${userId}`, userData);
    }

    public async changePassword(userId: string, password: string): Promise<any> {
        return this.axiosClient.put(`${this.adminRoute}/user/${userId}/password`, { password });
    }

    public async changeRole(userId: string, role: string): Promise<any> {
        return this.axiosClient.put(`${this.adminRoute}/user/${userId}/role`, { role });
    }

    public async deleteUser(userId: string): Promise<any> {
        return this.axiosClient.delete(`${this.adminRoute}/user/${userId}`);
    }
}
